module.exports = __webpack_public_path__ + "img/cta-ext-banner.91b93dd1.svg";